/* eslint-disable no-console */
import { ProtectedRouteProvider } from '@context/ProtectedRouteContext';
import { DefaultLayout } from '@layouts';
import Biotif from '@styles/Font';
import '@styles/global.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { AppProps } from 'next/app';
import { useEffect } from 'react';

const queryClient = new QueryClient();

const App = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    /** Register service-worker */
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('service-worker.js')
          .then((registration) => {
            console.log('Service Worker registered:', registration);
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      });
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <ProtectedRouteProvider>
        <main className={Biotif.variable}>
          <DefaultLayout>
            <Component {...pageProps} />
          </DefaultLayout>
        </main>
      </ProtectedRouteProvider>
    </QueryClientProvider>
  );
};

export default App;
